import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "@/lib/api";
import type { ApiResponse, UserProfile } from "@tacklefour/api-types";

/**
 * Ensures the authenticated user exists in the database.
 * Calls GET /users/me which auto-creates the user on first login.
 */
export function useEnsureUser() {
  const { isAuthenticated } = useAuth0();
  const api = useApiClient();

  return useQuery({
    queryKey: ["currentUser"],
    queryFn: () => api<ApiResponse<UserProfile>>("/users/me"),
    enabled: isAuthenticated,
    staleTime: 10 * 60 * 1000,
    retry: 2,
    select: (res) => res.data,
  });
}
